// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZqRa","type":"styles_type__26YUI","choices":"styles_choices__181PV"};